<template>
  <v-layout>
    <text-dialog
      v-if="isTextDialogOpen"
      :isTextDialogOpen="isTextDialogOpen"
      :type="typeTextDialog"
      :title="title"
      :lottieUrl="lottieUrl"
      :explanation="explanation || explanationDefault"
      :details="details || detailsDefault"
      :cancelButtonText="cancelButtonText || cancelButtonTextDefault"
      :confirmButtonText="confirmButtonText || confirmButtonTextDefault"
      :confirmButtonColor="confirmButtonColor"
      @confirm="confirm()"
      @cancel="closeDialog()"
    >
    </text-dialog>
  </v-layout>
</template>

<script>
import TextDialog from './TextDialog';

export default {
  name: 'premiumDialog',
  components: {
    TextDialog,
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    isTextDialogOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    explanation: {
      type: String,
      default: null,
    },
    details: {
      type: String,
      default: null,
    },
    cancelButtonText: {
      type: String,
      default: null,
    },
    confirmButtonText: {
      type: String,
      default: null,
    },
    lottieUrl: {
      type: String,
      default: 'images/rocket.json',
    },
  },
  data() {
    return {
      typeTextDialog: 'premium',
      explanationDefault: this.$t('premiumDialog.explanation.default'),
      detailsDefault: this.$t('premiumDialog.details'),
      cancelButtonTextDefault: this.$t('premiumDialog.cancelButtonText'),
      confirmButtonTextDefault: this.$t('premiumDialog.confirmButtonText'),
      confirmButtonColor: 'yellow darken-2',
      openConfirmDialog: false,
      confirmDialog: {
        title: this.$t('premiumDialog.confirmDialog.title'),
        explanation: this.$t('premiumDialog.confirmDialog.explanation'),
        typeTextDialog: 'confirmPremium',
        lottieUrl: 'images/success.json',
        confirmButtonText: this.$t(
          'premiumDialog.confirmDialog.confirmButtonText'
        ),
      },
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    currentAccount() {
      return this.$store.getters['accounts/currentAccount'];
    },
    currentAccountId() {
      return this.$store.getters['accounts/currentAccountId'];
    },
  },
  methods: {
    closeDialog() {
      this.$emit('cancel');
    },
    async confirm() {
      this.$emit('close-text-dialog');
    },
  },
  watch: {},
};
</script>

<style lang="sass"></style>
